<template>
  <v-card>
    <v-card-title>
      <span class="title">Change</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <form @submit.prevent="formSubmit">
        <v-text-field
          v-model="plant.plant"
          label="Plant"
          :error-messages="errors.collect('plant')"
          v-validate="'required|max:4'"
          :counter="4"
          data-vv-name="plant"
          required
        ></v-text-field>

        <v-text-field
          v-model="plant.description"
          label="Description"
          :error-messages="errors.collect('description')"
          v-validate="'required'"
          data-vv-name="description"
          required
        ></v-text-field>

        <v-select
          v-bind:items="companies"
          v-model="plant.company_code"
          label="Company code"
          item-value="company_code"
          :error-messages="errors.collect('company code')"
          v-validate="'required'"
          data-vv-name="company code"
          required
        >
          <template slot="selection" slot-scope="data">
            {{ data.item.company_code }} - {{ data.item.description }}
          </template>
          <template slot="item" slot-scope="data">
            {{ data.item.company_code }} - {{ data.item.description }}
          </template>
        </v-select>

        <v-btn @click="formSubmit" dark color="accent" :loading="isLoading" :disable="isLoading">update</v-btn>
        <v-btn to="/plant">cancel</v-btn>
      </form>
    </v-card-text>

    <v-snackbar :color="color" :timeout="timeout" bottom right v-model="snackbar">
      {{ text }}
      <v-btn flat dark @click.native="snackbar = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'change-plant',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      id: this.$route.params.id,
      plant: {},
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    }
  },
  methods: {
    ...mapActions(['changePlant', 'setActivePlant', 'fetchAllCompanies']),
    /**
     *
     */
    formSubmit: function () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.changePlant(this.plant)
            .then(() => {
              let response = this.getResponse
              this.snackbar = true
              this.text =
                response.status === 200
                  ? 'Changed successfully.'
                  : response.data.message
              this.color = response.status === 200 ? 'success' : 'error'
            })
            .catch(error => {
              console.log(error)
            })
        }
      })
    }
  },
  computed: {
    ...mapGetters({
      getResponse: 'getResponse',
      getActivePlant: 'getActivePlant',
      isLoading: 'getLoading',
      companies: 'getAllCompanies'
    })
  },
  mounted: function () {
    this.setActivePlant(this.id)
      .then(() => {
        this.plant = Object.assign({}, this.getActivePlant)
      })
      .catch(error => {
        console.log(error)
      })
    this.fetchAllCompanies()
      .then(() => {
        //  do nothing
      })
      .catch(error => {
        console.log(error)
      })
  }
}
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/plant/ChangePlant.vue